import fetch from "isomorphic-unfetch";
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, } from "@apollo/client";
import { Env } from "core/utils/env";
import { config } from "core/utils/config";
import { wait } from "core/utils/general";
import introspectionResult from "core/codegen/introspection-result";
/**
 * @TODO cleanup the `as NormalizedCacheObject` type cast
 */
export function createCache(initialState, typePolicies) {
    return new InMemoryCache({
        possibleTypes: introspectionResult.possibleTypes,
        typePolicies: typePolicies,
    }).restore(initialState);
}
/**
 * @NOTE The Apollo documentation is terrible.
 *
 * The watchQuery option:
 * I found this in the Apollo documentation:
 *
 *    Note: The <Query /> React component uses Apollo Client's watchQuery function.
 *    To set defaultOptions when using the <Query /> component, make sure to set
 *    them under the defaultOptions.watchQuery property.
 *
 * -> https://www.apollographql.com/docs/react/api/apollo-client/#example-defaultoptions-object
 *
 * We are not using the <Query /> React component. But we are using the hooks.
 * The documentation doesn't say anything about hooks. But I guess it's safe to
 * assume that hooks will also use the watchQuery default options.
 *
 * And I also tested it. Without setting
 *    watchQuery: { errorPolicy: "all" }
 * graphql errors crash the SSR process during getDataFromTree.
 *
 * The query option:
 * Not used when we think this is used. Probably used when you are manually
 * executing a query via the query function on the ApolloClient Class.
 * This is no the way we are doing queries.
 *
 * The mutate option:
 * We don't use mutation queries. But the defaultOptions object needs all
 * options to be defined.
 *
 * @NOTE These defaultOptions do not seem to work
 * @TODO figure out why???
 */
export var defaultOptions = {
    watchQuery: { fetchPolicy: "cache-and-network", errorPolicy: "none" },
    query: { fetchPolicy: "network-only", errorPolicy: "none" },
    mutate: { errorPolicy: "none" },
};
/**
 * Creates and configures the ApolloClient
 */
export function createApolloClient(initialState, typePolicies) {
    if (initialState === void 0) { initialState = {}; }
    var client = new ApolloClient({
        link: ApolloLink.from([
            getLogLink(),
            getDelayLink(0),
            getHTTPLink(),
        ]),
        cache: createCache(initialState, typePolicies),
        ssrMode: Env.isServer,
        defaultOptions: defaultOptions,
        ssrForceFetchDelay: 300,
    });
    return client;
}
function getDelayLink(ms) {
    return new ApolloLink(function (operation, forward) {
        wait(ms);
        return forward(operation);
    });
}
function getLogLink() {
    return new ApolloLink(function (operation, forward) {
        return forward(operation);
    });
}
function getHTTPLink() {
    return new HttpLink({
        uri: config.graphqlHttpEndpoint,
        headers: {
            "x-api-key": config.graphqlApiKey,
            "Referer": "https://vtm.be/",
        },
        fetch: fetch,
    });
}
